import ContentDonationRoot from "../components/content/ContentDonationRoot";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as boxActions from '../redux/modules/box';

function mapReduxDispatchToReactProps(dispatch) {
    return {
        onSelectDonationType: function (selectDonationType) {
            dispatch({ type: 'UPDATE_DONATIONTYPE', selectDonationType: selectDonationType });
        }.bind(this)
    };
}

function mapReduxStateToReactProps(state) {
    return { selectDonationType: state.box.selectDonationType };
}


export default connect(
    mapReduxStateToReactProps,
    (dispatch) => ({
        BoxActions: bindActionCreators(boxActions, dispatch)
    })
)(ContentDonationRoot);


//export default connect(mapReduxStateToReactProps, mapReduxDispatchToReactProps)(ContentDonationRoot);


// WEBPACK FOOTER //
// ./src/containers/ContentDonationRoot.js